"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FavoritesDialog = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _constants = require("../../constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); } // istanbul ignore file @preserve --controller for dialog
const Dialog = /*#__PURE__*/(0, _react.lazy)(async () => ({
  default: (await Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "FavoritesHeart_Dialog" */'./Dialog')))).Dialog
}));
const FavoritesDialog = ({
  lastUsedListId,
  mode,
  open,
  prefilledProductCodes,
  shouldRedirectOnSuccess,
  onClose
}) => {
  const {
    staticApiUrl
  } = (0, _configurationManager.useServiceUrls)(['staticApi']);
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    open: firstOpenDone,
    onOpen: setFirstOpenDone
  } = (0, _presentationHooks.useDisclose)();
  const translationsProps = (0, _react.useMemo)(() => ({
    defaultTranslationsWithNamespaces: {
      [_constants.translationsNamespace]: _constants.defaultTranslations
    },
    // eslint-disable-next-line no-console -- we want to log errors
    clientFetchConfiguration: {
      onError: console.error,
      tenant,
      baseUrl: staticApiUrl
    },
    language
  }), [language, staticApiUrl, tenant]);
  (0, _react.useEffect)(() => {
    if (open) {
      setFirstOpenDone();
    }
  }, [open, setFirstOpenDone]);
  if (!open && !firstOpenDone) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsProvider, {
    ...translationsProps,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
      namespace: _constants.translationsNamespace,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
        fallback: null,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Dialog, {
          lastUsedListId: lastUsedListId,
          mode: mode,
          open: open,
          prefilledProductCodes: prefilledProductCodes,
          shouldRedirectOnSuccess: shouldRedirectOnSuccess,
          onClose: onClose
        })
      })
    })
  });
};
exports.FavoritesDialog = FavoritesDialog;
//# sourceMappingURL=FavoritesDialog.js.map